// Legacy memory URL — Memories became a view of the unified Agents page
// (`/agents/memories`) in the 2026-07 nav review. Deep-link search params
// (`?status=&workflowId=&agentId=`) pass through untouched so existing
// links from /refinement/overview and /memory/metrics keep filtering.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../../lib/constants';
import type { RefinementMemoryStatus } from '../../lib/refinement-memory';

export interface IMemoryRedirectSearch {
  status?: RefinementMemoryStatus;
  workflowId?: string;
  agentId?: string;
}

export const Route = createFileRoute('/memory/')({
  validateSearch: (raw: Record<string, unknown>): IMemoryRedirectSearch => {
    const status =
      raw.status === 'approved' || raw.status === 'pending' || raw.status === 'rejected'
        ? raw.status
        : undefined;
    return {
      status,
      workflowId: typeof raw.workflowId === 'string' ? raw.workflowId : undefined,
      agentId: typeof raw.agentId === 'string' ? raw.agentId : undefined,
    };
  },
  beforeLoad: ({ search }) => {
    throw redirect({ to: routes.MEMORY, search, replace: true });
  },
  component: () => null,
});
